import { apiClient } from "./client";
import type { Drink, OrderedDrinks, DrinkCategory } from "../types";
import { DRINK_MENU } from "../constants/drinkMenu";

export type { DrinkCategory, Drink, OrderedDrinks };

const USE_MOCK = process.env.REACT_APP_USE_MOCK === "true";

// USE_MOCK=true 時のインメモリストア（REACT_APP_USE_MOCK=false の場合は MSW が処理）
const directMockOrderedDrinksStore = new Map<string, OrderedDrinks>();
let directMockFavoriteStore: Drink[] = [];

const MOCK_BASE_FEE = 1500;

export const drinksApi = {
  /** ドリンクメニュー取得（ローカル定数から返す） */
  getDrinkMenu: async (_eventId: string): Promise<DrinkCategory[]> => {
    return DRINK_MENU;
  },

  /** 注文ドリンク一覧取得 GET /event/:event_id/drinks */
  getEventOrderedDrinks: async (eventId: string): Promise<OrderedDrinks> => {
    if (USE_MOCK) {
      return directMockOrderedDrinksStore.get(eventId) ?? {
        basic_fee: MOCK_BASE_FEE,
        drinks: [],
        total_amount: MOCK_BASE_FEE,
      };
    }
    const { data } = await apiClient.get<OrderedDrinks>(`/event/${eventId}/drinks`);
    return data;
  },

  /** ドリンク注文 POST /event/:event_id/drinks */
  orderEventDrinks: async (eventId: string, drinks: Drink[]): Promise<void> => {
    if (USE_MOCK) {
      const existing = directMockOrderedDrinksStore.get(eventId) ?? {
        basic_fee: MOCK_BASE_FEE,
        drinks: [],
        total_amount: MOCK_BASE_FEE,
      };
      const drinksTotal = drinks.reduce((sum, d) => sum + d.price, 0);
      directMockOrderedDrinksStore.set(eventId, {
        basic_fee: existing.basic_fee,
        drinks,
        total_amount: existing.basic_fee + drinksTotal,
      });
      return;
    }
    await apiClient.post(`/event/${eventId}/drinks`, drinks);
  },

  /** 支払い完了 POST /event/:event_id/drinks/payment */
  completeEventDrinkPayment: async (eventId: string): Promise<void> => {
    if (USE_MOCK) return;
    await apiClient.post(`/event/${eventId}/drinks/payment`);
  },

  /** お気に入りドリンク一覧取得 GET /drink/favorites */
  getDrinkFavorites: async (): Promise<Drink[]> => {
    if (USE_MOCK) {
      return directMockFavoriteStore;
    }
    const { data } = await apiClient.get<Drink[]>("/drink/favorites");
    return data;
  },

  /** お気に入りドリンク登録 POST /drink/favorite */
  createDrinkFavorite: async (drinks: Drink[]): Promise<void> => {
    if (USE_MOCK) {
      directMockFavoriteStore = [...drinks];
      return;
    }
    await apiClient.post("/drink/favorite", drinks);
  },
};
